/* eslint-disable @typescript-eslint/no-explicit-any */

'use client';

import { useEffect } from 'react';

const EVENT_NAME = 'sold_unit_view';

export const PdpSoldUnitView = ({ stockNumber }: { stockNumber: string }) => {
  useEffect(() => {
    const w = window as any;

    w.VWO = w.VWO || [];
    if (!w.VWO.event) {
      // VWO may not be loaded yet (async smartcode), so queue the event on the VWO array
      // https://developers.vwo.com/docs/custom-events
      w.VWO.event = (...args: unknown[]) => w.VWO.push(['event', ...args]);
    }

    w.VWO.event(EVENT_NAME, { stockNumber });
  }, [stockNumber]);

  return null;
};
